(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("discountForm", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/discounts/discountFormView.html",
            controller: ["discountResource", "groupHierarchyResource", "calendarSettingsService", "messageService", "$scope", "$rootScope", "$q", "_", "$state", DiscountFormCtrl],
            controllerAs: "vm"
        };
        function DiscountFormCtrl(discountResource, groupHierarchyResource, calendarSettingsService, messageService, $scope, $rootScope, $q, _, $state) {
            var vm = this;
            vm.loading = true;
            vm.id = $state.params.id;
            vm.datePickerList = {
                startDate: false,
                endDate: false
            };
            //Date picker Config
            vm.format = "yyyy-MM-dd";
            calendarSettingsService.calendarSetup($scope);
            vm.openToggle = calendarSettingsService.openToggle;
            if ($state.current.name === "main.storefront.addDiscount") {
                groupHierarchyResource.query({ showAllGroups: false }, function (data) {
                    vm.groups = data;
                });
                vm.state = "Add";
                vm.pageTitle = "menu.storefront.addDiscount";
                vm.model = {
                    enabled: true,
                    discountUsePercentage: true,
                    startDate: new Date(),
                    endDate: null,
                    minimumCartAmount: null
                };
                vm.loading = false;
            }
            else {
                vm.state = "Edit";
                vm.pageTitle = "menu.storefront.editDiscount";
                groupHierarchyResource.query({ showAllGroups: true }, function (data) {
                    vm.groups = data;
                    discountResource.get({ id: vm.id }, function (model) {
                        vm.model = model;
                        if (model.startDate)
                            vm.model.startDate = new Date(model.startDate + "Z");
                        if (model.endDate)
                            vm.model.endDate = new Date(model.endDate + "Z");
                        if (vm.model.groupId) {
                            vm.group = _.find(vm.groups, { "id": vm.model.groupId });
                        }
                        vm.loading = false;
                    });
                });
            }
            vm.checkCodeIsAvailable = function (code) {
                return $q(function (resolve, reject) {
                    if (vm.state === "Add") {
                        discountResource.isCodeAvailable({ code: code }, function (result) {
                            if (result.value)
                                resolve(true);
                            else
                                reject();
                        });
                    }
                    else
                        resolve(true);
                });
            };
            vm.groupChanged = function () {
                if (vm.group)
                    vm.model.groupId = vm.group.id;
                else
                    vm.model.groupId = null;
            };
            vm.save = function () {
                if (vm.saving)
                    return;
                if (vm.form.$valid) {
                    vm.saving = true;
                    if (vm.state === "Add") {
                        discountResource.save({}, vm.model, function () {
                            messageService.success("storefront.discountForm.discountSaved");
                            $state.go("main.storefront.discounts");
                            $rootScope.$broadcast("reloadDiscountList");
                        }, function (error) {
                            vm.saving = false;
                            messageService.error(error);
                        });
                    }
                    else {
                        discountResource.update({ id: vm.model.id }, vm.model, function () {
                            messageService.success("storefront.discountForm.discountSaved");
                            $state.go("main.storefront.discounts");
                            $rootScope.$broadcast("reloadDiscountList");
                        }, function (error) {
                            vm.saving = false;
                            messageService.error(error);
                        });
                    }
                }
                else {
                    vm.showErrors = true;
                }
            };
            vm.cancel = function () {
                $state.go("main.storefront.discounts");
            };
            vm.generateCode = function () {
                var text = "";
                var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
                for (var i = 0; i < 10; i++)
                    text += possible.charAt(Math.floor(Math.random() * possible.length));
                vm.model.code = text;
            };
        }
    });
}());
